import { QuizGameStateModel } from './quiz-game-state.model';

export class InitQuizGame {
  static readonly type = '[Quiz] Init';
  constructor(public payload: QuizGameStateModel) {
    payload.currentQuestion = 0;
  }
}

export class PersistQuizUserInput {
  static readonly type = '[Quiz] Persist quiz user input';
  constructor(public payload: QuizGameStateModel) {}
}

export class SetCurrentQuestion {
  static readonly type = '[Quiz] Set current question';
  constructor(public payload: QuizGameStateModel) {}
}
